import { Component, OnInit, HostBinding, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { StateService, AuthService, AuctionService, MyAuctionLotService, AuctionLotService, CustomerService, SystemParametersService } from '../../../services';
import { FormFunctions } from '../../../functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BidIncrementService } from 'src/app/services/bid-increment.service';
import { fadeAnimation } from 'src/app/shared/animations';
import { AuctionLotItemComponent } from 'src/app/components';
import { debounceTime, distinctUntilChanged, tap, throttleTime } from 'rxjs/operators';
import { Observable, Subject, Subscription, timer } from 'rxjs';

// custom rxjs operator to debounce while the source emits the same values
function debounceDistinct<T>(delay: number) {
    return (source: Observable<T>): Observable<T> => {
        return new Observable(subscriber => {
            let hasValue = false;
            let lastValue: T | null = null;
            let durationSub: Subscription = null;

            const emit = () => {
                durationSub?.unsubscribe();
                durationSub = null;
                if (hasValue) {
                    // We have a value! Free up memory first, then emit the value.
                    hasValue = false;
                    const value = lastValue!;
                    lastValue = null;
                    subscriber.next(value);
                }
            };

            return source.subscribe(
                (value: T) => {
                    // new value received cancel timer
                    durationSub?.unsubscribe();
                    // emit lastValue if the value has changed
                    if (hasValue && value !== lastValue) {
                        const value = lastValue!;
                        subscriber.next(value);
                    }
                    hasValue = true;
                    lastValue = value;
                    // restart timer
                    durationSub = timer(delay).subscribe(() => {
                        emit();
                    });
                },
                error => {
                },
                () => {
                    emit();
                    subscriber.complete();
                    lastValue = null;
                });
        });
    }
}

@Component({
    selector: 'bid-list-card',
    styleUrls: ['./bid-list-card.component.scss'],
    templateUrl: './bid-list-card.component.html',
    host: { 'class': 'row auction-data bg-white flex-column flex-lg-row p-3 mb-2' },
    animations: [fadeAnimation],
})
export class BidListCardComponent extends AuctionLotItemComponent implements OnInit, OnDestroy {

    bidChanged = new Subject<number>();
    bidTyped = new Subject<number>();

    @HostBinding('class') get hostClasses() {
        const classList = ['row', 'auction-data', 'bg-white', 'flex-column', 'flex-lg-row', 'p-3', 'mb-2'];
        if (this.IsWinning) classList.push('border-right-green');
        else if (this.IsOutbid) classList.push('border-right-yellow');
        else classList.push('border-right-transparent');
        if (this.IsSelected) classList.push('selected');
        //if (!this.LotIsBiddable) classList.push('text-opacity-7');
        return classList;
    }

    constructor(
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public stateService: StateService,
        public modalService: NgbModal,
        public authService: AuthService,
        public formFunctions: FormFunctions,
        public auctionService: AuctionService,
        public auctionLotService: AuctionLotService,
        public myAuctionLotService: MyAuctionLotService,
        public bidIncrementService: BidIncrementService,
        public customerService: CustomerService,
        public systemParametersService: SystemParametersService,
    ) {
        super(router, activatedRoute, stateService, modalService, authService, formFunctions, auctionService, auctionLotService, myAuctionLotService, bidIncrementService, customerService, systemParametersService)
        var me = this;
    }

    ngOnInit(): void {
        super.ngOnInit();
        let me = this;

        if (me.MyAuctionLot) {
            if (me.MyAuctionLot?.SavedBidAmount) me.newBidAmt = me.MyAuctionLot.SavedBidAmount;
            // console.log('Setting saved bid amount', me.MyAuctionLot.SavedBidAmount);
        }

        // Automatically validate the user input if they stop typing for a bit, but haven't unfocused on the text input
        me.bidTyped.pipe(
            distinctUntilChanged(),
            debounceTime(2000),
        ).subscribe(bid => {
            me.bidChanged.next(me.newBidAmt);
        });

        // Handle the actual bid changed events, and prevent duplicate bidChanged events, such as when they tab away early
        me.bidChanged.pipe(
            distinctUntilChanged(),
            throttleTime(2050), // set the throttle timer a little bit higher than the debounce
        ).subscribe(bid => {
            me.AfterBidChanged();
        });
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    AfterBidChanged() {
        let me = this;
        me.AdjustToIncrement();
        me.SetSavedBid();
    }

    BidChange(force?: Boolean) {
        let me = this;
        //console.log('BidChange', me.newBidAmt, me.NewBidAmountValidated);
        me.NewBidAmountValidated = false;
        if (force) {
            me.bidChanged.next(me.newBidAmt);
        } else {
            me.bidTyped.next(me.newBidAmt);
        }
    }

    SetSavedBid(): Promise<void> {
        let me = this;
        if (me.MyAuctionLot) {
            return me.myAuctionLotService.SetSavedBid(me.lot.Id, me.newBidAmt).toPromise().then(data => {
                // console.log('SetSavedBid.end');
            });
        }
        return Promise.resolve();
    }

    HideList(event, bid) {
        let me = this;
        // console.log('HideList', event, bid);
        me.processing = true;
        if (me.MyAuctionLot.IsHidden) {
            me.myAuctionLotService.Unhide([bid.AuctionLotId]).subscribe((data) => {
                me.processing = false;
                // console.log('Unhide in watch list');
                bid.IsHidden = false;
                //me.myAuctionLotService.UpdateList();
            });
        }
        else {
            me.myAuctionLotService.Hide([bid.AuctionLotId]).subscribe((data) => {
                me.processing = false;
                // console.log('Hide in watch list');
                bid.IsHidden = true;
                //me.myAuctionLotService.UpdateList();
            });
        }
    }
}
